import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export const ConfidenceLogoInverted = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 28 28">
      <path
        d="M24 4.7619C24 4.34112 23.6589 4 23.2381 4H15.7619C15.3411 4 15 4.34112 15 4.7619V12.2381C15 12.6589 15.3411 13 15.7619 13H17.9048C21.2711 13 24 10.2711 24 6.90476V4.7619Z"
        fill="currentColor"
      />
      <rect
        width="9"
        height="9"
        rx="0.761905"
        transform="matrix(-1 0 0 1 13 4)"
        fill="currentColor"
      />
      <rect
        width="9"
        height="9"
        rx="4.5"
        transform="matrix(-1 0 0 1 24 15)"
        fill="currentColor"
      />
      <path
        d="M13 19.5C13 17.0147 10.9853 15 8.5 15C6.01472 15 4 17.0147 4 19.5V23.4375C4 23.7482 4.25184 24 4.5625 24H8.5C10.9853 24 13 21.9853 13 19.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
